import React, {Component} from 'react';
import {gpn} from "../GPN"
import req from "../req";
import Modal from "../sections/MUI/Modal";
import Field from "../sections/MUI/Field";
import Button from "../sections/MUI/Button";
import {toast} from "react-toastify";
import config from "../config";
import Icon from "../sections/MUI/Icon";

class Settings extends Component {

    state = {
        terms: "",
        help: "",
        about: "",
        contact: "",
        servicesNote: "",

        authVideoText: "",
        authVideoTextKeywords: "",
        authPercent: "75",

        contactTitle: "",
        contactData: [],

        modalTerms: false,
        modalHelp: false,
        modalAbout: false,
        modalContact: false,
        modalServicesNote: false,

        adminDescriptions: [],
        title: "",
        modalAdminDescription: false
    };

    componentDidMount() {
        config.scrollTop();
        this.get("terms");
        this.get("help");
        this.get("about");
        this.get("contact");
        this.get("servicesNote");
        this.get("authVideoText");
        this.get("authVideoTextKeywords");
        this.get("authPercent");
        this.getAdminDescriptions();
    }

    getAdminDescriptions() {
        req.post(`/admin-description`, {action: "list"})
            .then(r => {
                this.setState({
                    adminDescriptions: r.descriptions
                });
            });
    }

    get(key = "") {
        req.get(`/utilities?key=${key}`)
            .then(r => {
                if (r) {
                    if (r.data && key === "contact") {
                        this.setState({
                            [key]: r.value,
                            contactData: r.data.contact
                        });
                    } else {
                        this.setState({[key]: r.value});
                    }
                }
            });
    }

    set(key = "", data = null) {
        const value = this.state[key];
        let params = {
            key,
            value
        }
        if (data) {
            params = {
                ...params,
                data
            }
        }
        req.put(`/utilities`, params)
            .then(r => {
                if (r) {
                    toast.success("با موفقیت ثبت شد.");
                    this.get(key);
                }
            });
    }

    handleAddContact() {
        let {contactTitle, contactData} = this.state;
        contactTitle = contactTitle.toString().trim();
        if (contactTitle.length === 11) {
            contactData.push(contactTitle);
            this.setState({
                contactData,
                contactTitle: ""
            });
        }
    }

    handleDeleteContact(index = -1) {
        if (index !== -1) {
            let {contactData} = this.state;
            contactData.splice(index, 1);
            this.setState({contactData});
        }
    }

    handleInputChangeContact(index, value) {
        let {contactData} = this.state;
        contactData[index] = value;
        this.setState({contactData});
    }

    submitAdminDescription() {
        let {title} = this.state;
        let t = title.toString().trim();

        if (t !== "") {
            this.setState({
                title: ""
            });
            req.post(`/admin-description`, {action: "create", title: t})
                .then(r => {
                    this.getAdminDescriptions();
                });
        }

    }

    deleteAdminDescription(title = "") {
        req.post(`/admin-description`, {action: "delete", title})
            .then(r => {
                this.getAdminDescriptions();
            });
    }

    render() {
        let {
            terms,
            help,
            about,
            contact,
            servicesNote,

            authVideoText,
            authVideoTextKeywords,
            authPercent,

            contactTitle,
            contactData,

            modalTerms,
            modalHelp,
            modalAbout,
            modalContact,
            modalServicesNote,

            adminDescriptions,
            title,
            modalAdminDescription
        } = this.state;
        return (
            <div className="settings">
                <Modal display={modalServicesNote}
                       title="نکات ثبت سفارشات خدمات"
                       onCloseClick={() => this.setState({modalServicesNote: false})}>
                    <Field name="servicesNote"
                           value={servicesNote}
                           type="textarea"
                           row={4}
                           label="نکات"
                           placeholder="نکات مربوط به ثبت سفارشات خدمات (توسط کاربر) را وارد کنید ..."
                           onChange={(name, value) => this.setState({[name]: value})}
                           maxLength={20000}/>

                    <br/>
                    <div className="row col-md-5">
                        <Button icon="check"
                                onClick={() => this.set("servicesNote")}>ذخیره کردن</Button>
                    </div>
                </Modal>
                <Modal display={modalAdminDescription}
                       onCloseClick={() => this.setState({modalAdminDescription: false})}
                       title="فیلتر توضیحات مدیریت">
                    <div className="modal-admin-descriptions">
                        <div className="row">
                            <div className="col">
                                <Field name="title"
                                       value={title}
                                       onChange={(name, value) => this.setState({[name]: value})}
                                       maxLength={200}
                                       label="توضیح مدیریت"/>
                            </div>
                            <div className="col-auto">
                                <Icon i="plus" solid className="add-icon"
                                      onClick={() => this.submitAdminDescription()}/>
                            </div>
                        </div>

                        <div className="list">
                            {adminDescriptions.map((d, i) =>
                                <article key={"ad" + i}>
                                    <div className="row">
                                        <div className="col">
                                            <div className="title">{d}</div>
                                        </div>
                                        <div className="col-auto">
                                            <Icon i="trash" className="delete-icon"
                                                  onDoubleClick={() => this.deleteAdminDescription(d)}/>
                                        </div>
                                    </div>
                                </article>
                            )}
                        </div>
                    </div>
                </Modal>
                <Modal display={modalContact}
                       title="تماس با ما"
                       onCloseClick={() => this.setState({modalContact: false})}>

                    <div className="modal-contact">

                        <Field name="contact"
                               value={contact}
                               type="textarea"
                               label="متن تماس با ما"
                               maxLength={25000}
                               onChange={(name, value) => this.setState({[name]: value})}
                               row={10}/>

                        <div className="row">
                            <div className="col">
                                <Field name="contactTitle"
                                       value={contactTitle}
                                       label="شماره تماس"
                                       type="number"
                                       style={{direction: "ltr"}}
                                       maxLength={11}
                                       onChange={(name, value) => this.setState({[name]: value})}/>
                            </div>
                            <div className="col-auto">
                                <Icon i="plus" solid
                                      className="icon-add"
                                      onClick={() => this.handleAddContact()}/>
                            </div>
                        </div>

                        <div className="data">
                            {contactData.map((c, i) =>
                                <div className="row" key={"contact" + i}>
                                    <div className="col">
                                        <Field name={"contactTitle" + i}
                                               value={c}
                                               label="شماره تماس"
                                               type="number"
                                               style={{direction: "ltr"}}
                                               maxLength={11}
                                               onChange={(name, value) => this.handleInputChangeContact(i, value)}/>
                                    </div>
                                    <div className="col-auto">
                                        <Icon i="minus" solid
                                              className="icon-delete"
                                              onClick={() => this.handleDeleteContact()}/>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="row justify-content-center">
                            <Button onClick={() => this.set("contact", {contact: contactData})}>ذخیره کردن</Button>
                        </div>

                    </div>
                </Modal>
                <Modal display={modalAbout}
                       title="درباره ما"
                       onCloseClick={() => this.setState({modalAbout: false})}>
                    <Field name="about"
                           value={about}
                           type="textarea"
                           label="درباره ما"
                           maxLength={25000}
                           onChange={(name, value) => this.setState({[name]: value})}
                           row={15}/>

                    <div className="row justify-content-center">
                        <Button onClick={() => this.set("about")}>ذخیره کردن</Button>
                    </div>
                </Modal>
                <Modal display={modalHelp}
                       title="راهنمای خرید اقساطی"
                       onCloseClick={() => this.setState({modalHelp: false})}>
                    <Field name="help"
                           value={help}
                           type="textarea"
                           label="راهنمای خرید"
                           maxLength={25000}
                           onChange={(name, value) => this.setState({[name]: value})}
                           row={15}/>

                    <div className="row justify-content-center">
                        <Button onClick={() => this.set("help")}>ذخیره کردن</Button>
                    </div>
                </Modal>

                <Modal display={modalTerms}
                       title="قوانین"
                       onCloseClick={() => this.setState({modalTerms: false})}>
                    <Field name="terms"
                           value={terms}
                           type="textarea"
                           label="قوانین"
                           maxLength={25000}
                           onChange={(name, value) => this.setState({[name]: value})}
                           row={15}/>

                    <div className="row justify-content-center">
                        <Button onClick={() => this.set("terms")}>ذخیره کردن</Button>
                    </div>
                </Modal>

                <div className="row justify-content-center">
                    <div className="col-4">
                        <Button onClick={() => this.setState({modalTerms: true})}>قوانین</Button>
                    </div>
                    <div className="col-4">
                        <Button onClick={() => this.setState({modalHelp: true})}>راهنمای خرید اقساطی</Button>
                    </div>
                    <div className="col-4">
                        <Button onClick={() => this.setState({modalAbout: true})}>درباره ما</Button>
                    </div>
                    <div className="col-4">
                        <Button onClick={() => this.setState({modalContact: true})}>تماس با ما</Button>
                    </div>
                    <div className="col-4">
                        <Button onClick={() => this.setState({modalServicesNote: true})}>نکته سفارش خدمات</Button>
                    </div>
                    <div className="col-4">
                        <Button
                            backgroundColor="#222E50"
                            onClick={() => this.setState({modalAdminDescription: true})}>توضیحات مدیریت
                            (سفارشات)</Button>
                    </div>
                    <div className="col-12">
                        <br/><br/>
                        <div className="row">
                            <div className="col-8">
                                <Field name="authVideoText"
                                       value={authVideoText}
                                       maxLength={2000}
                                       label="متن احراز هویت ویدیو"
                                       onChange={(name, value) => this.setState({[name]: value})}/>
                            </div>
                            <div className="col-4">
                                <Button icon="check" onClick={() => this.set("authVideoText")}>ذخیره</Button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-8">
                                <Field name="authVideoTextKeywords"
                                       value={authVideoTextKeywords}
                                       maxLength={2000}
                                       label="کلیدواژه های ضروری احراز هویت ویدیو"
                                       onChange={(name, value) => this.setState({[name]: value})}/>
                            </div>
                            <div className="col-4">
                                <Button icon="check" onClick={() => this.set("authVideoTextKeywords")}>ذخیره</Button>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-3">
                                <Field name="authPercent"
                                       type="number"
                                       value={authPercent}
                                       style={{
                                           direction: "ltr"
                                       }}
                                       maxLength={3}
                                       label="حداقل درصد تطبیق احراز هویت"
                                       onChange={(name, value) => {
                                           value = value.toString().trim();
                                           if (value === "") {
                                               value = "0";
                                           }
                                           let v = !isNaN(Number(value)) ? Number(value) : 75;
                                           if (v <= 100 && v >= 0) {
                                               this.setState({[name]: v.toString()})
                                           }
                                       }}/>
                            </div>
                            <div className="col-3">
                                <Button icon="check" onClick={() => {
                                    this.set("authPercent")
                                }}>ذخیره</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default gpn(Settings);